<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
    font-family: '斗鱼追光体2.0';
    src: url('./assets/斗鱼追光体2.0.ttf');
}
@font-face {
    font-family: 'SourceHanSansCN-Medium';
    src: url('./assets/SourceHanSansCN-1.000/SourceHanSansCN-Medium.otf');
}
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue